"use strict";
// NOTE !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// This file must synced with `@zapier/toolbox-frontend-app`'s `guessUserAgentInfo`.
// If you change this code, please change there, too.
Object.defineProperty(exports, "__esModule", { value: true });
var DEVICE_TYPES = {
    phone: 'phone',
    phablet: 'phablet',
    tablet: 'tablet',
    desktop: 'desktop',
};
var containsAnyUa = function (substrings) { return function (ua) {
    // Load testing tools such as ab and autocannon, and Datadog Synthetics
    // (simulated user requests), do not send a user agent string.
    if (typeof ua !== 'string') {
        return false;
    }
    var normalizedUa = ua.toLowerCase();
    return substrings
        .map(function (substring) { return substring.toLowerCase(); })
        .some(function (substring) { return normalizedUa.includes(substring); });
}; };
var isTablet = containsAnyUa(['ipad', 'kfapwi']);
var isPhablet = containsAnyUa(['nexus']);
var isMobile = containsAnyUa(['iphone', 'mobile']);
var guessUserAgentInfo = function (userAgent) {
    // Order is important since subsequent conditions are more generic.
    // Specifically, guessing a tablet looks for specific devices,
    // as does phablet, and then mobile looks for devices or a `mobile`
    // string in the UA. Desktop is the fallback.
    if (isTablet(userAgent)) {
        return { deviceType: DEVICE_TYPES.tablet, width: 660 };
    }
    if (isPhablet(userAgent)) {
        return { deviceType: DEVICE_TYPES.phablet, width: 420 };
    }
    if (isMobile(userAgent)) {
        return { deviceType: DEVICE_TYPES.phone, width: 320 };
    }
    return { deviceType: DEVICE_TYPES.desktop, width: 1024 };
};
exports.default = guessUserAgentInfo;
